<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="is_goods_delieverd" name="is_goods_delieverd" rules="required" v-slot="{ errors }">
              <small class="label">11.1 Are goods delivered in the company's own vehicles or by contract hauliers? Please give details</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" name="is_goods_delieverd" :closeOnSelect="true" v-model="form.is_goods_delieverd" :options="['company-vehicle', 'contract-haulier']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="is_goods_delieverd_text" name="is_goods_delieverd_text" rules="required" v-slot="{ errors }">
              <small class="label">Please give details</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_goods_delieverd_text" class="w-full" v-model="form.is_goods_delieverd_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_vehicle_condition" name="is_vehicle_condition" rules="" v-slot="{ errors }">
              <small class="label">11.2 If a contractor is used, is the condition of the vehicle inspected prior to loading? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_vehicle_condition" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_vehicle_condition" vid="is_vehicle_condition_text" name="is_vehicle_condition_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please give details</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_vehicle_condition_text" class="w-full" v-model="form.is_vehicle_condition_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_storage" name="is_storage" rules="" v-slot="{ errors }">
              <small class="label">11.3 Are they accredited to the BRC standard for storage and distribution? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_storage" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_storage" vid="is_storage_text" name="is_storage_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_storage_text" class="w-full" v-model="form.is_storage_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_onsite_lab" name="is_onsite_lab" rules="" v-slot="{ errors }">
              <small class="label">11.4 Is there an on-site laboratory?  </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_onsite_lab" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_onsite_lab" vid="is_onsite_lab_text" name="is_onsite_lab_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_onsite_lab_text" class="w-full" v-model="form.is_onsite_lab_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="offtesting" name="offtesting" rules="required" v-slot="{ errors }">
              <small class="label">If off-site testing is required, which laboratory facilities are used? Please state accreditation body</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="offtesting" class="w-full" v-model="form.offtesting" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>




        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_transport_storage_complete === 1"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import vSelect from "vue-select";

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_goods_delieverd: false,
          is_vehicle_condition: false,
          is_storage: false,
          is_onsite_lab: false
        },
        id: null,
        status: {}
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_transport_storage_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.UpdateManufactureTransportDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Transport & Storage Details Updated!')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.CreateManufactureTransportDetails(this.form))
          this.showSuccessMessage('Manufacture Transport & Storage Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureTransportDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_transport_storage_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
